import {inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export class ConfirmAppointmentWithDealerSellerUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.appointmentSlotVOFactory
   * @param {Function} deps.dealerEntityFactory
   * @param {Service} deps.getInstantOfferByAdSellerService
   * @param {Function} deps.instantOfferEntityFactory
   * @param {Function} deps.invalidAppointmentRequestErrorFactory
   * @param {HTTPSellerRepository} deps.repository
   */
  constructor({
    appointmentSlotVOFactory,
    dealerEntityFactory,
    getInstantOfferByAdSellerService,
    instantOfferEntityFactory,
    invalidAppointmentRequestErrorFactory,
    repository
  }) {
    super()

    this._appointmentSlotVOFactory = appointmentSlotVOFactory
    this._dealerEntityFactory = dealerEntityFactory
    this._getInstantOfferByAdSellerService = getInstantOfferByAdSellerService
    this._instantOfferEntityFactory = instantOfferEntityFactory
    this._invalidAppointmentRequestErrorFactory = invalidAppointmentRequestErrorFactory
    this._repository = repository
  }

  /**
   * @param {Object} params
   * @param {Object} params.appointment
   * @param {String} params.appointment.from
   * @param {String} params.appointment.to
   * @param {String} params.dealerId
   * @param {String} params.instantOfferId - Instant Offer ID
   * @return {Promise}
   */
  @tracer({metric: 'ConfirmAppointmentWithDealerSellerUseCase#execute'})
  @inlineError
  async execute({appointment, dealerId, instantOfferId, isNextAppointment = false} = {}) {
    if (!instantOfferId || !appointment || !dealerId)
      return Promise.reject(this._invalidAppointmentRequestErrorFactory())

    const appointmentVO = this._appointmentSlotVOFactory(appointment)
    const dealerEntity = this._dealerEntityFactory({id: dealerId})
    const instantOfferEntity = this._instantOfferEntityFactory({instantOfferId})

    const [error, response] = await this._repository.confirmAppointmentWithDealer({
      appointmentVO,
      dealerEntity,
      instantOfferEntity,
      isNextAppointment
    })

    if (error) return Promise.reject(error)

    return response.toJSON()
  }
}
